import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import { getGlobalMobileClasses } from '../../../themes';
import AuthUserContainer from '../../../containers/AuthUser';
import TimeClockSection from './TimeClockSection';
import MobileHeader from '../common/MobileHeader';
import justSphereLogo from '../../../images/logos/justSphere.svg';
import StarIcon from '@material-ui/icons/Star';
import { Paper } from '@material-ui/core';

//const stlBlue = '#1289d4';
const styles = (theme) => {
	return {
		...getGlobalMobileClasses(theme),
		welcomeContainer: {
			display: 'flex',
			alignItems: 'center',
			marginTop: '2vw',
			paddingBottom: '3vw',
			textAlign: 'center',
		},
		welcomeText: {
			//textTransform: 'uppercase',
			fontFamily: "'Roboto Condensed', sans-serif",
			fontSize: '250%',
			color: '#333',
			textAlign: 'left',
			width: '100%',
			fontWeight: '900',
		},
		contentTitle: {
			display: 'flex',
			alignItems: 'center',
			fontSize: '175%',
			borderBottom: '1px solid #ddd',
			paddingBottom: '2vw',
			marginBottom: '2vw',
		},
		loginWarning: {
			margin: '2vw 0',
			padding: '4vw',
			borderRadius: '1vw',
			//border: '1px solid #eee',
			//borderBottom: '1px solid #ddd',
			fontSize: '130%',
			backgroundColor: '#0c5d90',
			color: 'white',
		},
		boldName: {
			fontSize: '110%',
			fontWeight: 800,
			display: 'inline-block',
			borderBottom: '2px solid #E9791E',
			margin: `0 1vw`,
			paddingBottom: 2,
		},
		justSphereLogo: {
			display: 'inline-block',
			width: '150vw',
			height: '150vw',
			backgroundImage: `url('${justSphereLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
			opacity: '.1',
			zIndex: -1,
		},
	};
};

class MobileDashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'clockInDateTime',
			lastPunchInfoResults: undefined,
			showClockInSuccessful: false,
			showClockOutSuccessful: false,
			recentTimeClockShifts: undefined,
		};
	}

	componentDidMount() {}

	render() {
		const { authUser } = this.props;

		let innerRender =
			authUser?.role === 'driver' ? this.renderDriverDashboard : this.renderNonDriverDashboard;

		return <Fragment>{innerRender()}</Fragment>;
	}

	renderDriverDashboard = () => {
		const { classes, authUser } = this.props;
		return (
			<div>
				<MobileHeader showLogo={true} />
				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						overflow: 'hidden',
						backgroundColor: '#f6f6f7',
					}}
				>
					<div className={classes.justSphereLogo} />
				</div>

				<div className={classes.globalContent} style={{ padding: '3vw' }}>
					<div className={classes.welcomeContainer}>
						<div className={classes.welcomeText}>Welcome to Sphere Mobile!</div>
					</div>

					<Paper>
						<div className={classes.loginWarning}>
							If you are not
							<span className={classes.boldName}>
								{' '}
								{authUser.firstName} {authUser.lastName}{' '}
							</span>{' '}
							please log out and log back in under your own account.
						</div>
					</Paper>
					<TimeClockSection />

					<Paper style={{ padding: '3vw', marginTop: '2vw' }}>
						<div style={{ fontSize: '150%', paddingBottom: '1.1vw' }}>
							<StarIcon
								style={{
									width: '5vw',
									height: '5vw',
									position: 'relative',
									top: '0.8vw',
									marginRight: '.5vw',
									color: '#0d8bdb',
								}}
							/>
							<strong>NEW!</strong> Net Gallons on Products
						</div>
						<span style={{ fontSize: '130%' }}>
							Sphere Mobile now has support to collect Net Gallons from the BOL for all commodities.
							When entering product info look for this field and make sure you fill it out.
						</span>
					</Paper>
				</div>
			</div>
		);
	};

	renderNonDriverDashboard = () => {
		const { classes } = this.props;
		return <div className={classes.contentTitle}>Sphere mobile for drivers only.</div>;
	};
}

MobileDashboard.propTypes = {
	authUser: PropTypes.object,
};
export default _.flow([withStyles(styles), AuthUserContainer])(MobileDashboard);
